<style lang="scss" scoped>
$trigger-color: #6b74e7;
$trail-color: #8e65e6;
$main-px: 10px;

/*div {*/
/*  border: 2px dotted crimson;*/
/*}*/

button {
  cursor: pointer;
  border: unset;
}

.ml-auto {
  margin-left: auto;
}

.bold {
  font-weight: bold;
}

.text-small {
  font-size: 12px;
}

.btn_close {
  color: var(--color-neutral-light);
  cursor: pointer;
  font-size: 16px;

  &:hover {
    color: var(--color-text-light);
  }
}

.btn_circle-add {
  background: transparent;

  &:hover {
    color: var(--color-text-light);
  }
}

.checkmark {
  color: var(--color-info-dark);
  font-size: 16px;
}

.cyan {
  color: var(--color-info-dark);
}

.gray {
  color: var(--color-neutral-light);
}

.so-color {
  color: var(--color-text-dark);
}

.trigger-color {
  color: $trigger-color;
}

.trigger {
  display: flex;
  align-items: center;
  gap: 5px;

  &-label {
    color: $trigger-color;
    text-align: right;
  }
}

.trail-color {
  color: $trail-color;
}

.trailing {
  display: flex;
  align-items: center;
  color: $trail-color;
  gap: 5px;

  &-label {
    text-align: right;
  }

  .input {
    width: calc(50% - 22px);
  }
}

hr {
  border: 1px solid var(--color-background);
  border-top: none;
}

.tpmarketswith {
  font-size: 12px;
  color: var(--color-accent-dark);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-bottom: 1px dashed var(--color-accent-dark);
  text-decoration: none;
}

.update-orders {
  cursor: pointer;
  color: var(--color-text-dark);
}

.refresh-liq-price {
  display: flex;
  cursor: pointer;
  color: var(--color-text-dark);
  transform: rotate(0deg);
  transition: 0s;

  &:hover:not(:disabled) {
    color: var(--color-text);
  }

  &.rotate {
    transition: 0.5s;
    transform: rotate(360deg);
  }

  &:disabled {
    cursor: default;
    color: var(--color-neutral);
  }
}

.edit-trade {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  font-size: 14px;
  overflow: auto;
}

#header {
  position: sticky;
  top: 0;
  background-color: var(--color-card-dark);
  padding: 10px $main-px 5px;
}

#main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  background-color: var(--color-card);
  padding: 5px $main-px 10px;
  overflow-y: auto;
  scroll-behavior: smooth;
}

#footer {
  position: sticky;
  bottom: 0;
  background-color: var(--color-card-dark);
  padding: 5px $main-px 15px;
}

.text-button {
  --color: var(--color-accent-dark);

  display: flex;
  align-items: center;
  width: fit-content;
  background: transparent;
  border: unset;
  color: var(--color);
  font-size: 12px;
  border-bottom: 1px dashed var(--color);
  margin: 0 auto;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &.tp {
    --color: var(--color-success-light);
  }

  &.sl {
    --color: var(--color-danger-light);
  }

  &:hover {
    --color: var(--color-text-light);
  }
}

.symbol-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  font-size: 18px;
}

.id-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;

  .leverage {
    font-size: 12px;
    color: var(--color-text-light);
  }

  .id {
    color: var(--color-text-dark);
  }
}

.time-wrapper {
  font-size: 12px;
  text-align: left;
}

.comment {
  cursor: pointer;

  &:hover {
    color: #8c8eba;
  }

  &_edit {
    color: var(--color-text-dark);
    max-width: 130px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 12px;
    font-weight: bold;
    text-align: left;
  }

  &_add {
    color: var(--color-accent-light);
    font-size: 18px;
  }
}

.active-tp-trainling {
  color: var(--color-accent-dark);
  text-align: center;
}

.so {
  $column-gap: 5px;
  $row-gap: 5px;
  text-align: left;

  /* rows */
  & > * {
    display: flex;
    align-items: center;
    gap: $column-gap;

    &:not(:last-child) {
      margin-bottom: $row-gap;
    }

    /* columns */
    & > * {
      flex: 1;

      &.span-2 {
        flex: 2;
      }
    }
  }

  &__header {
    font-size: 12px;
    color: var(--color-text-dark);
    margin-bottom: 2px !important;
  }

  &__block {
    display: flex;
    gap: $column-gap;
    align-items: center;
  }
}

.stop-loss {
  font-size: 14px;

  &__row {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 5px;

    &:not(:last-child) {
      margin-bottom: 5px;
    }

    & > :first-child {
      width: 140px;
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .input {
      max-width: 200px;
      width: 40%;
      min-width: 100px;
    }
  }
}

.take-profit {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    margin-bottom: 5px;
  }

  &__tpmarket-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 46px;
  }

  &__switch-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
  }

  &__trail-prcnt-wrapper {
     display: flex;
     align-items: center;
     justify-content: flex-start;
     gap: 2px;
   }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin-bottom: 5px;

    & > * {
      flex: auto;
    }
  }

  &__prcnt {
    max-width: 10%;
    min-width: 42px;
  }

  &__alert-wrapper {
    margin-left: -5px;
    margin-bottom: 3px;
  }

  &__alert {
    color: mediumvioletred;
  }

  &__msg {
    min-height: 20px;
    margin-bottom: -3px;
  }
}

.error-msg {
  min-height: 21px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  gap: 20px;

  &__btn {
    $color: var(--color-text-dark);
    $hover-color: #adb1f0;

    color: $color;
    cursor: pointer;
    min-width: 25px;

    circle {
      stroke: $color;
    }

    path {
      fill: $color;
    }

    &:hover {
      color: $hover-color;

      circle {
        stroke: $hover-color;
      }

      path {
        fill: $hover-color;
      }
    }

    &_disabled {
      color: var(--color-neutral);
      cursor: default;

      &:hover {
        color: var(--color-neutral);
      }
    }
  }

  &__save-btn {
    height: 30px;
  }
}
</style>

<template>
  <div>
    <div class="edit-trade box">
      <header id="header">
        <div class="symbol-wrapper">
          <CoinIcon :symbol="trade.Symbol" />
          <span>{{ symbol }}</span>
          <Icon
            v-if="trade.Buys || trade.Orders"
            class="update-orders"
            :title="$text.tr('Показать сделки')"
            type="ios-list-box-outline"
            @click="updateTradeOrders"
          />
          <span class="ml-auto">
            <span
              class="gray"
              v-if="tradeStatus"
            >
              {{ tradeStatus }}
            </span>
            <span
              v-else
              :title="$text.tr('Общая прибыль (rPnL+uPnL)')"
              :class="{ggreen: parseFloat(trade.Profit) >= 0, gred: parseFloat(trade.Profit) < 0}"
            >{{ trade.Profit }} {{ trade.Symbol.split('_')[1] }} | {{ trade.ProfitPct }}%</span>
          </span>
          <button
            v-if="$store.state.sys.tradeExchange.ExchId === 'BIF'"
            class="refresh-liq-price"
            :class="{rotate: isRotateLiqPrice}"
            :disabled="isDisabledLiqPrice"
            :title="$text.tr('Обновить цену ликвидации')"
            @click="updateLiquidatePrice()"
          >
            <Icon
              size="28"
              type="ios-refresh"
            />
          </button>
        </div>
        <div v-if="trade.Info && trade.Info.Comment">
          <p
            v-if="trade.Info && trade.Info.Comment"
            class="comment comment_edit"
            @click="showEditCommentModal(trade)"
          >
            {{ trade.Info.Comment }}
          </p>
        </div>
        <div
          class="id-wrapper"
          :class="{ggreen: trade.Side === 'B', gred: trade.Side === 'S'}"
        >
          <span>{{ trade.Side === 'B' ? $text.tr('покупка') : $text.tr('продажа') }}</span>
          <span
            class="leverage"
            v-if="($store.state.sys.tradeExchange.ExchId === 'BIF' ||
            ($store.state.sys.tradeExchange.ExchId === 'OKX' && symbol.includes('-PERP'))) &&
            trade.Info && trade.Info.Leverage"
          >{{ trade.Info.Leverage }}X
          </span>
          <span class="id" style="cursor: pointer" @click="$copyToClipboardAndNotify(trade.Id)">
            #{{ trade.Id }}
          </span>
          <Icon
            v-if="!trade.Info || !trade.Info.Comment"
            type="md-add"
            class="comment comment_add"
            :title="$text.tr('добавить комментарий')"
            @click="showEditCommentModal(trade)"
          />
          <div
            v-if="trade.Status === 'SLTP' && trade.Profit !== trade.Upnl"
            class="ml-auto"
            :class="{ggreen: parseFloat(trade.Upnl) >= 0, gred: parseFloat(trade.Upnl) < 0}"
            :title="$text.tr('Нереализованная прибыль (uPnL)')"
          >
            {{ trade.Upnl }} {{ trade.Symbol.split('_')[1] }}
          </div>
        </div>
        <div class="time-wrapper">
          <time>{{ new Date(trade.Created).toLocaleString('ru-RU').replace(',', '') }}</time>
        </div>
      </header>
      <main id="main">
        <!-- SO -->
        <div
          v-if="(tradeSOs && tradeSOs.length > 0) || trade.Status !== 'ORDSUBMIT'"
          class="so"
        >
          <div class="so__header">
            <span>
              {{ $text.tr('КОЛ-ВО') }}
            </span>
            <span>
              {{ $text.tr('ЦЕНА ВХОДА') }}
            </span>
            <span>
              {{ $text.tr('СУММА') }}
            </span>
          </div>
          <div
            v-if="(trade.Status !== 'ORDSUBMIT' && trade.Status !== 'COND') || (trade.QtyNofee !== '0' && trade.Status !== 'COND') || (trade.Status === 'ORDSUBMIT' && trade.IntOrderId !== '')"
            class="cyan bold"
          >
            <div :title="trade.Info && parseFloat(trade.Info.QtyLeft) > 0 && trade.Info.QtyLeft !== trade.Qty ? $text.tr('Остаток монет в сделке / Общее кол-во монет в сделке') : $text.tr('Кол-во монет в сделке')">
              {{ trade.Info && parseFloat(trade.Info.QtyLeft) > 0 && trade.Info.QtyLeft !== trade.Qty ? trade.Info.QtyLeft + ' / ' : '' }}{{ trade.Qty }}
            </div>
            <div :title="$text.tr('Средняя цена входа')">
              <span>{{ trade.Price }}</span>
              <Tooltip
                v-if="trade.Status === 'ORDSUBMIT' && trade.IntOrderId !== ''"
                placement="right"
                max-width="260"
              >
                <Icon
                  style="margin-left: 5px; margin-top: -3px;"
                  type="ios-information-circle-outline"
                  color="#F08080"
                />
                <div slot="content">Cтарая версия сделки. Чтобы отредактировать цену, создайте новую сделку</div>
              </Tooltip>
            </div>
            <div :title="$text.tr('Сумма выхода по рынку / Инвестировано средств')">
              {{ trade.Amount }} / {{ excAmount }}
            </div>
          </div>
          <hr v-if="(trade.Status !== 'ORDSUBMIT' && trade.Status !== 'COND')
        || (trade.QtyNofee !== '0' && trade.Status !== 'COND')" />
          <div
            v-if="(trade.Status !== 'ORDSUBMIT' && trade.Status !== 'COND')
        || (trade.QtyNofee !== '0' && trade.Status !== 'COND')
        || (trade.Status === 'ORDSUBMIT' && trade.IntOrderId !== '')
        || (trade.Status === 'ORDSUBMIT' && tradeSOs.length > 1)"
            class="bold"
          >
            <div :title="$text.tr('Кол-во монет в сделке после усреднений')">{{ totalQty }}</div>
            <div :title="$text.tr('Средняя цена входа после усреднений')">{{ avgPriceNew }}</div>
            <div :title="$text.tr('Сумма инвестиций после усреднений')">{{ totalAmount }}</div>
          </div>
          <template v-for="(so, index) in tradeSOs">
            <div :key="'so-' + index">
              <CustomInput
                size="small"
                v-model="so.Qty"
                :disabled="so.Status === 'EXC' || so.Trail"
                @on-change="soQtyChanged(index)"
              />
              <div class="so__block">
                <CustomInput
                  size="small"
                  v-model="so.Price"
                  :disabled="so.Status === 'EXC' || so.Trail"
                  @on-change="soPriceChanged(index)"
                />
                <button
                  v-if="trade.Status !== 'COND' && so.Status !== 'EXC' && !so.Trail"
                  class="btn_circle-add"
                  :class="{ 'trigger-color': so.Trigger !== '0' || so.Option === 'TRIGGER', 'trail-color': so.TrailPct !== '0' || so.Option === 'TRAILING', 'so-color': so.Option === 'EMPTY' }"
                  :disabled="so.Trail"
                  @click="soOptionsClick(so)"
                >
                  <Icon type="md-add-circle" />
                </button>
              </div>
              <div class="so__block">
                <CustomInput
                  size="small"
                  v-model="so.Amount"
                  :disabled="so.Status === 'EXC' || so.Trail"
                  @on-change="soAmountChanged(index)"
                />
                <Icon
                  v-if="so.Status === 'EXC'"
                  class="checkmark"
                  type="md-checkmark"
                />
                <Icon
                  v-else-if="!so.Cond"
                  class="btn_close"
                  type="md-close"
                  @click="cancelBuy(so)"
                />
                <Tooltip
                  v-if="errorByPrice('so', so.Price)"
                  max-width="300"
                  style="color: darkred; font-weight: normal"
                  placement="left"
                  :content="errorByPrice('so', so.Price)"
                >
                  <Icon
                    style="color: mediumvioletred; margin-bottom: 3px;"
                    size="15"
                    type="md-alert"
                  ></Icon>
                </Tooltip>
              </div>
            </div>
            <div
              v-if="trade.Status !== 'COND' && so.Status !== 'EXC' && so.Option === 'TRIGGER'"
              :key="'so-trigger-' + index"
            >
              <label
                :for="'so-trigger-id' + index"
                class="trigger-label"
              >
                TRIGGER
              </label>
              <div class="trigger">
                <CustomInput
                  :id="'so-trigger-id' + index"
                  size="small"
                  v-model="so.Trigger"
                />
              </div>
              <Tooltip
                v-visible="trade.Side === 'B' ? parseFloat(so.Trigger) <= parseFloat(so.Price) : parseFloat(so.Trigger) >= parseFloat(so.Price)"
                max-width="300"
                style="color: darkred; font-weight: normal"
                placement="bottom"
                :content="$text.tr('Некорректный триггер')"
              >
                <Icon
                  style="color: mediumvioletred;"
                  type="md-alert"
                ></Icon>
              </Tooltip>
            </div>
            <div
              v-else-if="trade.Status !== 'COND' && so.Status !== 'EXC' && so.Option === 'TRAILING'"
              :key="'so-trailing-' + index"
              class="trailing"
            >
              <label
                :for="'so-trailing-id-' + index"
                class="trailing-label"
              >
                TRAILING
              </label>
              <div class="trailing span-2">
                <template v-if="!so.Trail">
                  <CustomInput
                    :id="'so-trailing-id-' + index"
                    class="input"
                    size="small"
                    v-model="so.TrailPct"
                  />
                  <span> % </span>
                </template>
                <template v-else>
                  <span>{{ $text.tr('АКТИВИРОВАН')}} {{ so.TrailPct }}%</span>
                  <Icon
                    type="md-checkmark"
                    size="13"
                    style="padding-left: 2px"
                  />
                </template>
              </div>
            </div>
          </template>
        </div>
        <button
          v-if="canAddNewSO"
          class="text-button"
          @click="addBuy"
        >
          <Icon type="md-add" />
          <span>{{ safetyText }}</span>
        </button>
        <!-- STOP LOSS !-->
        <button
          v-if="!$store.state.trade.slAdded"
          class="text-button sl"
          @click="addstoploss"
        >
          <Icon type="md-add" />
          <span>STOP LOSS</span>
        </button>
        <div
          v-if="trade.Sltp && trade.Sltp.Status === 'TPT'"
          class="active-tp-trainling"
        >
          <span>{{ $text.tr('Активирован TP Trailing') }}</span>
        </div>
        <div
          v-if="$store.state.trade.slAdded"
          class="stop-loss"
        >
          <div class="stop-loss__row">
            <label
              for="stop-loss-input"
              class="text-small gred"
            >STOP LOSS</label>
            <div
              v-if="trailing"
              class="input"
            >
              <CustomInput
                id="stop-loss-input"
                size="small"
                v-model="trade.Info.SlPct"
                style="width: 50%"
              />
              <span
                class="gred"
                style="display: inline-block; padding-left: 3px; padding-top: 3px"
              >%</span>
            </div>
            <div
              v-else
              class="input"
            >
              <CustomInput
                id="stop-loss-input"
                size="small"
                v-model="trade.Sltp.SlPrice"
              >
                <span slot="append">
                  <div style="width: 34px; font-size: 14px;">{{ trade.Symbol.split('_')[1] }}</div>
                </span>
              </CustomInput>
            </div>
            <span class="bold">100%</span>
            <Icon
              class="btn_close"
              type="md-close"
              @click="cancelSL"
            />
          </div>
          <div class="stop-loss__row">
            <div class="gred">
              <i-switch
                size="small"
                v-model="slTrailingEnabled"
              />
              <span>trail</span>
              <span v-if="slTrailingEnabled && trade.Sltp && parseFloat(trade.Sltp.SlTrailPct) > 0">
                {{ parseFloat(trade.Sltp.SlTrailPct).toFixed(1) }}%
              </span>
            </div>
            <span
              v-if="!trailing"
              :class="{ gred: parseFloat(expSLProfit.pft) < 0, ggreen: parseFloat(expSLProfit.pft) >= 0 }"
            >
              {{ parseFloat(expSLProfit.pft) >= 0 ? $text.tr('Прибыль') : $text.tr('Убыток') }}: {{ expSLProfit.pft }} {{ trade.Symbol.split('_')[1] }} ({{ expSLProfit.pct }}%)
            </span>
          </div>
          <div class="stop-loss__row gred">
            <div>
              <i-switch
                size="small"
                v-model="slTimeoutEnabled"
              />
              <label for="stop-loss-timeout">timeout</label>
              <Tooltip
                placement="right"
                max-width="260"
                :delay="500"
              >
                <Icon
                  type="ios-information-circle-outline"
                  color="var(--color-text-dark)"
                />
                <div slot="content">
                  {{ $text.tr('При активации Stop Loss система будет ожидать указанное время. Если после этого цена останется в зоне Stop Loss, то сделка закроется рыночным ордером. Данная функция используется для защиты от сквиза.') }}
                  <a
                    style="color: var(--color-accent-dark)"
                    target="_blank"
                    :href="$text.tr('https://doc.capico.app/v/ru/terminal/sl/timeout')"
                  >{{ $text.tr('Подробнее') }}</a>
                </div>
              </Tooltip>
            </div>
            <CustomInput
              v-visible="slTimeoutEnabled"
              id="stop-loss-timeout"
              size="small"
              v-model="slTimeout"
              style="width: 44px;"
            />
            <span v-if="slTimeoutEnabled">
              {{ $text.tr('сек.')}}
            </span>
          </div>

          <div class="stop-loss__row gred" v-if="$store.state.sys.tradeExchange.ExchId === 'BYF'">
            <div>
              <i-switch
                size="small"
                v-model="slExchEnabled"
              />
              <label for="stop-loss-timeout">exch</label>
              <Tooltip
                placement="right"
                max-width="260"
                :delay="500"
              >
                <Icon
                  type="ios-information-circle-outline"
                  color="var(--color-text-dark)"
                />
                <div slot="content">
                  {{ $text.tr('Биржевой стоп — это стоп ордер, который размещается на самой бирже. Он полностью закрывает всю позицию по данной паре и в данном направлении торговли.') }}
                  <a
                    style="color: var(--color-accent-dark)"
                    target="_blank"
                    :href="$text.tr('https://doc.capico.app/v/ru/terminal/sltp#sle')"
                  >{{ $text.tr('ИНСТРУКЦИЯ') }}</a>
                </div>
              </Tooltip>
            </div>
          </div>

          <div
            class="stop-loss__row gred"
            v-if="($store.state.sys.tradeExchange.ExchId === 'BIN' || $store.state.sys.tradeExchange.ExchId === 'BIF' || $store.state.sys.tradeExchange.ExchId === 'BIM' || $store.state.sys.tradeExchange.ExchId === 'BYF') && $store.state.sys.demo === false"
          >
            <div>
              <i-switch
                size="small"
                v-model="$store.state.trade.slcEnabled"
              />
              <span>{{ $text.tr('закрытие свечи') }}</span>
            </div>
            <Select
              v-visible="$store.state.trade.slcEnabled"
              v-model="slcPeriod"
              style="font-size: 18px; max-width: 70px"
              size="small"
            >
              <Option
                v-for="(period, index) in slcPeriods"
                :value="period.min"
                :key="'period-' + index"
              >{{ period.interval }}</Option>
            </Select>
          </div>
        </div>
        <!-- TAKE PROFIT -->
        <div
          class="take-profit"
          v-if="trade.tpsteps && trade.tpsteps.length"
        >
          <div class="take-profit__header">
            <div>
            <div class="ggreen text-small">
              TAKE PROFIT
            </div>
            <div class="take-profit__tpmarket-wrapper">
              <span
                v-if="haveActiveTPs"
                class="tpmarketswith"
                @click="tptypeswitch"
              >{{ TpMarket ? 'MARKET' : 'LIMIT' }}</span>
            </div>
            </div>
            <div
              v-if="haveActiveTPs"
              :class="{ggreen : !isBreakevenDisabled, gray : isBreakevenDisabled}"
              class="take-profit__switch-wrapper"
            >
              <i-switch
                :disabled="isBreakevenDisabled"
                size="small"
                v-model="breakeven"
              /> {{$text.tr('БУ')}}
              <Tooltip
                placement="right"
                max-width="240"
                :delay="500">
<!--                :content="$text.tr('Безубыток: после исполнения первой цели Take Profit, Stop Loss будет установлен на уровень входа в сделку')-->
                <Icon
                  style="margin-top: -3px;"
                  size="18"
                  type="ios-information-circle-outline"
                  color="var(--color-text-dark)"
                />
              <div slot="content">
                {{ $text.tr('Безубыток: после исполнения первой цели Take Profit, Stop Loss будет установлен на уровень входа в сделку.') }}
                <a
                    style="color: var(--color-accent-dark)"
                    target="_blank"
                    :href="$text.tr('https://doc.capico.app/v/ru/terminal/breakeven')"
                >{{ $text.tr('Подробнее') }}</a>
              </div>
              </Tooltip>
            </div>
            <div>
              <!--            TRAILING-->
              <div
                  style="margin-top: 2px"
                class="take-profit__trail-prcnt-wrapper"
                v-if="haveActiveTPs"
              >
                <Tooltip
                    placement="left"
                    max-width="240"
                    :delay="500"
                >
                  <Icon
                      style="margin-top: -5px;"
                      size="18"
                      type="ios-information-circle-outline"
                      color="var(--color-text-dark)"
                  />
                  <div slot="content">
                    {{ $text.tr('Функция Take Profit Trailing позволяет следовать за движением цены на расстоянии заданного процента.') }}
                    <a
                        style="color: var(--color-accent-dark)"
                        target="_blank"
                        :href="$text.tr('https://doc.capico.app/v/ru/terminal/trailing/take-profit-trailing')"
                    >{{ $text.tr('Подробнее') }}</a>
                  </div>
                </Tooltip>
                <i-switch
                  size="small"
                  v-model="tpTrailingEnabled"
                />
                <label style="width: 30px" for="trailing-pct">trail</label>
                <div
                  v-visible="tpTrailingEnabled"
                  class="take-profit__switch-wrapper"
                >
                  <CustomInput
                    id="trailing-pct"
                    v-model="tpTrailingPct"
                    style="width: 50px;"
                    size="small"
                  />
                  <span>%</span>
                </div>
              </div>
              <!--            AUTO-->
              <div
                  class="take-profit__trail-prcnt-wrapper"
                  style="margin-top: 3px"
                  v-if="haveActiveTPs"
              >
                <Tooltip
                    placement="left"
                    max-width="240"
                    :delay="500"
                >
                  <Icon
                      style="margin-top: -5px;"
                      size="18"
                      type="ios-information-circle-outline"
                      color="var(--color-text-dark)"
                  />
                  <div slot="content">
                    {{ $text.tr('После каждого исполненного усреднения функция Auto выставляет Take Profit на уровень предыдущей покупки (для лонг сделок) или предыдущей продажи (для шорт сделок).') }}
                    <a
                        style="color: var(--color-accent-dark)"
                        target="_blank"
                        :href="$text.tr('https://doc.capico.app/v/ru/terminal/auto')"
                    >{{ $text.tr('Подробнее') }}</a>
                  </div>
                </Tooltip>
                <i-switch
                    size="small"
                    v-model="tpAutoEnabled"
                    :disabled="isAutoTpDisabled"
                />
                <label style="width: 30px" for="auto-tp-pct">auto</label>
                <div
                    v-visible="tpAutoEnabled"
                    class="take-profit__switch-wrapper"
                >
                  <CustomInput
                      id="auto-tp-pct"
                      v-model="tpAutoPct"
                      style="width: 50px;"
                      size="small"
                      minus
                  />
                  <span>%</span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="(step, index) in tradeTPs"
            :key="'step-' + index"
            class="take-profit__item"
          >
            <CustomInput
              v-model="step.Qty"
              size="small"
              :placeholder="$text.tr('КОЛ-ВО').toLowerCase()"
              :disabled="step.Status === 'EXC'"
              @on-change="onTakeProfitQtyChange(step)"
            />
            <CustomInput
              v-model="step.Price"
              size="small"
              :placeholder="$text.tr('ЦЕНА').toLowerCase()"
              :disabled="step.Status === 'EXC'"
              @on-change="setTakeProfitAmount(step)"
            />
            <CustomInput
              v-model="step.Amount"
              size="small"
              :placeholder="$text.tr('СУММА').toLowerCase()"
              :disabled="step.Status === 'EXC'"
              @on-change="onTakeProfitAmountChange(step)"
            />
            <CustomInput
              v-model="step.Pct"
              class="take-profit__prcnt"
              size="small"
              :disabled="step.Status === 'EXC'"
              @on-change="onTakeProfitPctChange(step)"
            />
            <span :class="{gray: step.Status === 'EXC'}"> % </span>
            <Icon
              v-if="step.Status === 'EXC'"
              size="16"
              type="md-checkmark"
            />
            <Icon
              v-else
              class="btn_close"
              type="md-close"
              @click="cancelTP(step)"
            />
            <div class="take-profit__alert-wrapper">
              <Tooltip
                v-if="errorByPrice('step', step.Price)"
                max-width="300"
                style="color: darkred;"
                placement="left"
                :content="errorByPrice('step', step.Price)"
              >
                <Icon
                  class="take-profit__alert"
                  size="15"
                  type="md-alert"
                ></Icon>
              </Tooltip>
            </div>
          </div>
          <div class="take-profit__msg">
            <Tooltip
              v-if="stepsProfit() !== stepsProfit(true)"
              placement="left"
              max-width="140"
              :delay="500"
              :content="$text.tr('После усреднений: ') + stepsProfit(true) + ' (' + stepsProfitPct(true) + '%)'"
            >
              <div :class="{ gred: parseFloat(stepsProfit()) < 0, ggreen: parseFloat(stepsProfit()) >= 0 }">{{ parseFloat(stepsProfit()) >= 0 ? $text.tr('Прибыль') : $text.tr('Убыток') }}: {{ stepsProfit() }} {{ trade.Symbol.split('_')[1] }} ({{ stepsProfitPct() }}%)</div>
            </Tooltip>
            <div
              v-else
              :class="{ gred: parseFloat(stepsProfit()) < 0, ggreen: parseFloat(stepsProfit()) >= 0 }"
            >{{ parseFloat(stepsProfit()) >= 0 ? $text.tr('Прибыль') : $text.tr('Убыток') }}: {{ stepsProfit() }} {{ trade.Symbol.split('_')[1] }} ({{ stepsProfitPct() }}%)</div>
          </div>
        </div>
        <button
          v-if="canAddNewTP"
          class="text-button tp"
          @click="addnewtp"
        >
          <Icon type="md-add" />
          <span>TAKE PROFIT</span>
        </button>
      </main>
      <footer id="footer">
        <div class="error-msg">
          <span
            v-if="error != ''"
            class="gred"
          >{{ error }}</span>
          <span
            v-else
            class="yell"
          >{{ warn }}</span>
        </div>
        <div class="toolbar">
          <Icon
            type="ios-close-circle-outline"
            size="30"
            class="toolbar__btn"
            :title="$text.tr('Закрыть окно') + ' (ESC)'"
            @click="cancel"
          />
          <Icon
            @click="switchToPreviousTrade()"
            :title="$text.tr('Предыдущая сделка')"
            size="30"
            type="ios-arrow-dropleft"
            class="toolbar__btn"
            :class="{'toolbar__btn_disabled': isFirstTrade}"
          />
          <Icon
            @click="switchToNextTrade()"
            :title="$text.tr('Следующая сделка')"
            size="30"
            type="ios-arrow-dropright"
            class="toolbar__btn"
            :class="{'toolbar__btn_disabled': isLastTrade}"
          />
          <Button
            :loading="loading"
            long
            @click="save"
            :disabled="error !== '' || haveTriggerErrors"
            size="small"
            class="toolbar__save-btn"
          >{{ $text.tr('СОХРАНИТЬ') }}</Button>
          <svg
            v-visible="trade.Status !== 'ORDSUBMIT' && trade.Status !== 'COND'"
            @click="panicSellByMode"
            class="toolbar__btn"
            width="25"
            height="28"
            viewBox="0 0 50 56"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            <title>{{ trade.Side === 'B' ? $text.tr('Продать по рынку') : $text.tr('Выкупить по рынку') }}</title>
            <circle
              cx="25"
              cy="28"
              r="24"
              stroke-width="2"
            />
            <path d="M23.626 46.15V42.076C22.058 41.964 20.518 41.628 19.006 41.068C17.494 40.508 16.122 39.738 14.89 38.758L16.402 36.49C17.55 37.358 18.726 38.058 19.93 38.59C21.162 39.094 22.394 39.402 23.626 39.514V29.14L21.484 28.552C19.384 27.908 17.816 27.04 16.78 25.948C15.744 24.828 15.226 23.442 15.226 21.79C15.226 19.69 15.982 17.982 17.494 16.666C19.034 15.322 21.078 14.594 23.626 14.482V11.122H25.642V14.566C27.042 14.706 28.4 15.07 29.716 15.658C31.06 16.218 32.306 16.96 33.454 17.884L31.9 20.068C30.948 19.284 29.94 18.654 28.876 18.178C27.812 17.674 26.734 17.338 25.642 17.17V26.872L27.784 27.502C30.052 28.174 31.676 29.056 32.656 30.148C33.664 31.212 34.168 32.612 34.168 34.348C34.168 36.504 33.37 38.296 31.774 39.724C30.206 41.124 28.162 41.908 25.642 42.076V46.15H23.626ZM22.45 25.948L23.626 26.284V17.044C21.946 17.1 20.602 17.548 19.594 18.388C18.586 19.2 18.082 20.264 18.082 21.58C18.082 22.644 18.418 23.526 19.09 24.226C19.79 24.926 20.91 25.5 22.45 25.948ZM26.776 30.106L25.642 29.728V39.514C27.322 39.402 28.68 38.898 29.716 38.002C30.752 37.106 31.27 35.972 31.27 34.6C31.27 33.508 30.934 32.64 30.262 31.996C29.618 31.324 28.456 30.694 26.776 30.106Z" />
          </svg>
        </div>
      </footer>
    </div>
    <EditCommentModal
      @on-cancel="$store.state.editCommentModal.show = false"
      @setComment="setComment"
    />
    <TradeOrdersModal
      :show="tradeOrdersModalShow"
      :orders="trade.Orders"
      :symbol="trade.Symbol"
      :comment="trade.Info ? trade.Info.Comment : ''"
      :side="trade.Side"
      @on-cancel="tradeOrdersModalShow = false"
    />
  </div>
</template>

<script>
import CoinIcon from '@/components/common/CoinIcon.vue'
import Decimal from 'decimal.js'
import SlimApi from '@/util/slimapi'
import SlimApis from '@/util/slimapis'
import Util from '@/util/util'
import Constants from '@/util/constants'
import terminal from '@/services/terminal'
import Vue from 'vue'
import TradeOrdersModal from '@/components/MainPage/Terminal/TradeOrdersModal'
import EditCommentModal from '@/components/MainPage/Terminal/EditCommentModal'
import CustomInput from '@/components/common/CustomInput'
import { So } from '../../../util/types'

export default {
  name: 'EditTrade',
  components: { TradeOrdersModal, EditCommentModal, CustomInput, CoinIcon },
  data () {
    return {
      isSwitchingTrade: false,
      loading: false,
      error: '',
      warn: '',
      slTrailingEnabled: false,
      tpTrailingEnabled: false,
      tpAutoEnabled: false,
      slTimeoutEnabled: false,
      slExchEnabled: false,
      slTimeout: 60,
      breakeven: false,
      tpAutoPct: 0,
      errRespTP: {},
      errRespSO: {},
      TpMarket: false,
      tradeOrdersModalShow: false,
      tradeTPs: [],
      tradeSOs: [],
      numberOfActiveTPs: 8,
      slcEnabled: false,
      slcPeriod: 1,
      comment: '',
      isRotateLiqPrice: false,
      isDisabledLiqPrice: false
    }
  },
  watch: {
    tpAutoEnabled () {
      if (this.tpAutoEnabled) {
        this.tpTrailingEnabled = false
      }
    },
    tpTrailingPct () {
      this.checkAllErrors()
    },
    tpTrailingEnabled () {
      if (this.tpTrailingEnabled) {
        this.$store.state.trade.slcEnabled = false
        this.tpAutoEnabled = false
        this.slExchEnabled = false
      }
      this.checkAllErrors()
    },
    slExchEnabled () {
      if (this.slExchEnabled) {
        this.slTrailingEnabled = false
        this.slTimeoutEnabled = false
        this.tpTrailingEnabled = false
        this.$store.state.trade.slcEnabled = false
      }
    },
    slTrailingEnabled () {
      if (this.slTrailingEnabled) {
        this.$store.state.trade.slcEnabled = false
        this.slExchEnabled = false
      }
    },
    slTimeoutEnabled () {
      if (this.slTimeoutEnabled) {
        this.$store.state.trade.slcEnabled = false
        this.slExchEnabled = false
      }
    },
    '$store.state.trade.slcEnabled' (slcEnabled) {
      if (slcEnabled) {
        this.slTrailingEnabled = false
        this.slTimeoutEnabled = false
        this.tpTrailingEnabled = false
        this.slExchEnabled = false
      }
      this.checkAllErrors()
    },
    isBreakevenDisabled () {
      if (this.isBreakevenDisabled) {
        this.breakeven = false
      }
    },
    breakeven () {
      this.checkAllErrors()
    },
    '$store.state.sys.demo' () {
      this.$store.state.trade.editTradeId = null
      this.$store.state.trade.editTrade = null
    },
    '$store.state.trade.showTV' (showTV) {
      if (!showTV) {
        this.$store.state.trade.editTradeId = null
        this.$store.state.trade.editTrade = null
      }
    },
    'trade.Sltp.SlPrice' (slPrice) {
      this.checkAllErrors()
    },
    'trade.tpsteps': {
      handler () {
        if (!this.trade.tpsteps) {
          return
        }

        this.tradeTPs = this.trade.tpsteps.slice(-this.numberOfActiveTPs)
        this.setTPstepsAmount()

        this.checkAllErrors()
      },
      deep: true
    },
    trade (newTrade, oldTrade) {
      if (oldTrade && newTrade && oldTrade.Id !== newTrade.Id) {
        this.refresh()
      }
    },
    '$store.state.sys.lastPrice' () {
      this.isSwitchingTrade = false
      this.checkAllErrors()
    },
    'trade.Price' () {
      this.checkAllErrors()
    },
    'trade.so': {
      handler () {
        if (this.trade.so) {
          this.tradeSOs = this.trade.so.slice(-4)
        } else {
          this.tradeSOs = []
        }
        if (this.trade.Status === 'ORDSUBMIT' || this.trade.Status === 'COND') {
          this.resetTpSteps(false)
        }

        this.checkAllErrors()
        if (
          this.trailing &&
          this.trade.Sltp &&
          this.trade.Sltp.SlPrice !== '0'
        ) {
          this.trade.Info.SlPct = '1'
          if (this.trade.Sltp) {
            this.trade.Sltp.SlPrice = '0'
          }
        }
        if (
          !this.trailing &&
          this.trade.Info &&
          this.trade.Info.SlPct !== '0'
        ) {
          this.trade.Info.SlPct = '0'
          this.addstoploss()
        }

        if (this.trade.so.length < 2 || this.isAutoTpDisabled) {
          this.tpAutoEnabled = false
          this.tpAutoPct = 0
        }
      },
      deep: true
    }
  },
  computed: {
    currentQty () {
      if (
        (this.trade.Status === 'ORDSUBMIT' || this.trade.Status === 'COND') &&
        this.tradeSOs[0]
      ) {
        return this.tradeSOs[0].Qty
      } else {
        return this.trade.Qty
      }
    },
    tradeStatus () {
      if (
        this.trade.Status === 'ORDSUBMIT' &&
        this.trade.QtyNofee > 0 &&
        this.trade.QtyNofee !== this.trade.Qty
      ) {
        return `${this.$text.tr('ЧАСТИЧНО ИСПОЛНЕН')} ${this.trade.QtyNofee}/${
          this.trade.Qty
        }`
      }

      if (this.trade.Status === 'ORDSUBMIT' && !this.trailing) {
        return this.$text.tr('ОРДЕР РАЗМЕЩЕН')
      }

      if (this.trade.Status === 'COND') {
        return this.$text.tr('ОТЛОЖЕННЫЙ ОРДЕР')
      }

      if (this.trailing) {
        return 'TRAILING'
      }

      return null
    },
    tradesFiltered () {
      return this.$store.state.trades.tradesFiltered
    },
    isFirstTrade () {
      return this.$store.state.trades.choosenTradeIndex <= 0
    },
    isLastTrade () {
      const currentIndex = this.$store.state.trades.choosenTradeIndex
      const lastIndex = this.tradesFiltered.length - 1

      return currentIndex >= lastIndex
    },
    symbolsFilter () {
      return this.$store.state.data.symbolsfilter
    },
    avgPriceNew () {
      let qty =
        this.trade.Info && parseFloat(this.trade.Info.QtyLeft) > 0
          ? new Decimal(this.trade.Info.QtyLeft)
          : new Decimal(this.trade.Qty)
      if (this.trade.Status === 'ORDSUBMIT') {
        qty = new Decimal(0)
      }
      let sum = new Decimal(this.trade.Price).mul(qty)
      const actSO = this.trade.so
        ? this.trade.so.filter(obj => obj.Status === 'ACT')
        : []
      actSO.forEach(slim => {
        qty = qty.add(slim.Qty)
        sum = sum.add(new Decimal(slim.Qty).mul(slim.Price))
      })
      const priceDec = this.symbolsFilter[this.$store.state.trade.symbol].PriceDec
      return sum.div(qty).toDP(priceDec, Decimal.ROUND_DOWN)
    },
    // avgPrice () {
    //   var priceDec = this.$store.state.data.symbolsfilter[this.$store.state.trade.symbol].PriceDec
    //   return this.totalAmount.div(this.totalQty).toDP(priceDec, Decimal.ROUND_DOWN)
    // },
    excAmount () {
      return this.excOrders.reduce(
        (total, obj) => total.add(new Decimal(obj.Qty).mul(obj.Price)),
        new Decimal(0)
      )
    },
    excOrders () {
      return this.trade.so
        ? this.trade.so.filter(obj => obj.Status === 'EXC')
        : []
    },
    totalAmount () {
      return this.trade.so
        ? this.trade.so.reduce(
          (total, obj) => total.add(new Decimal(obj.Qty).mul(obj.Price)),
          new Decimal(0)
        )
        : new Decimal(0)
    },
    totalQty () {
      return this.trade.so
        ? this.trade.so.reduce(
          (total, obj) => total.add(obj.Qty),
          new Decimal(0)
        )
        : new Decimal(0)
    },
    trailing () {
      let trail = false
      if (
        this.trade.Status === 'ORDSUBMIT' &&
        this.trade.so &&
        this.trade.so.length > 0
      ) {
        trail = true
        this.trade.so.forEach(so => {
          if (so.TrailPct === '0') {
            trail = false
          }
        })
      }
      return trail
    },
    symbol () {
      if (
        this.$store.state.sys.tradeExchange.ExchId === 'FTX' &&
        this.trade.Symbol.includes('-')
      ) {
        return this.trade.Symbol.replace('_USD', '')
      }
      return this.trade.Symbol.replace('_', '/')
    },
    slcPeriods () {
      if (this.$store.state.sys.tradeExchange.ExchId === 'FTX') {
        return [
          { min: 1, interval: '1m' },
          { min: 5, interval: '5m' },
          { min: 15, interval: '15m' },
          { min: 60, interval: '1h' },
          { min: 240, interval: '4h' },
          { min: 1440, interval: '1D' }
        ]
      } else {
        return [
          { min: 1, interval: '1m' },
          { min: 5, interval: '5m' },
          { min: 15, interval: '15m' },
          { min: 30, interval: '30m' },
          { min: 60, interval: '1h' },
          { min: 120, interval: '2h' },
          { min: 240, interval: '4h' },
          { min: 360, interval: '6h' },
          { min: 720, interval: '12h' },
          { min: 1440, interval: '1D' }
        ]
      }
    },
    haveTriggerErrors () {
      for (let i = 0; i < this.tradeSOs.length; i++) {
        if (this.tradeSOs[i].Status === 'EXC') {
          continue
        }
        if (
          this.trade.Side === 'B' &&
          this.tradeSOs[i].Trigger !== '0' &&
          parseFloat(this.tradeSOs[i].Trigger) <=
            parseFloat(this.tradeSOs[i].Price)
        ) {
          return true
        }
        if (
          this.trade.Side === 'S' &&
          this.tradeSOs[i].Trigger !== '0' &&
          parseFloat(this.tradeSOs[i].Trigger) >=
            parseFloat(this.tradeSOs[i].Price)
        ) {
          return true
        }
      }
      return false
    },
    canAddNewTP () {
      if (!this.trade.tpsteps) {
        return true
      }
      let actSteps = 0
      for (let i = 0; i < this.trade.tpsteps.length; i++) {
        if (
          this.trade.tpsteps[i].Status === 'ACT' ||
          this.trade.tpsteps[i].Status === 'NEW'
        ) {
          actSteps += 1
        }
      }
      if (actSteps < this.numberOfActiveTPs) {
        return true
      }
      return false
    },
    canAddNewSO () {
      if (this.trade.Status === 'COND') {
        return false
      }
      if (!this.trade.so) {
        return true
      }
      let actSOs = 0
      for (let i = 0; i < this.trade.so.length; i++) {
        if (this.trade.so[i].Status === 'ACT') {
          actSOs += 1
        }
      }
      if (actSOs < 4) {
        return true
      }
      return false
    },
    safetyText () {
      if (this.trade.Side === 'B') {
        return this.$text.tr('ПОКУПКА')
      } else {
        return this.$text.tr('ПРОДАЖА')
      }
    },
    isAutoTpDisabled () {
      if (this.trade.so.length > 1 && this.trade.so[this.trade.so.length - 1].Status === 'ACT') {
        if (this.trade.Side === 'B') {
          let actmax = 0
          let excmin = Number.MAX_VALUE
          this.trade.so.forEach(buy => {
            // console.log(JSON.stringify(buy))
            if (buy.Status === 'ACT' && parseFloat(buy.Price) > actmax) {
              actmax = parseFloat(buy.Price)
              // console.log('actmin: ' + actmin)
            }
            if (buy.Status === 'EXC' && parseFloat(buy.Price) < excmin) {
              excmin = parseFloat(buy.Price)
              // console.log('excmax: ' + excmax)
            }
          })
          if (excmin > actmax) {
            return false
          }
        } else {
          let actmin = Number.MAX_VALUE
          let excmax = 0
          this.trade.so.forEach(buy => {
            // console.log(JSON.stringify(buy))
            if (buy.Status === 'ACT' && parseFloat(buy.Price) < actmin) {
              actmin = parseFloat(buy.Price)
              // console.log('actmin: ' + actmin)
            }
            if (buy.Status === 'EXC' && parseFloat(buy.Price) > excmax) {
              excmax = parseFloat(buy.Price)
              // console.log('excmax: ' + excmax)
            }
          })
          if (actmin > excmax) {
            return false
          }
        }
      }
      return true
    },
    isBreakevenDisabled () {
      let disabled = false
      if (
        this.trade.Sltp &&
        this.trade.Sltp.SlPrice !== '0' &&
        this.slTrailingEnabled
      ) {
        disabled = true
      } else {
        if (this.trade.tpsteps && this.trade.tpsteps.length > 1) {
          const stepPrice = terminal.returnDecimalValue(
            this.trade.tpsteps[0].Price
          )
          if (
            this.trade.Side === 'B' &&
            new Decimal(this.trade.Price).greaterThanOrEqualTo(stepPrice)
          ) {
            return true
          } else if (
            this.trade.Side === 'S' &&
            new Decimal(this.trade.Price).lessThanOrEqualTo(stepPrice)
          ) {
            return true
          }
          this.trade.tpsteps.forEach(step => {
            if (step.Status === 'EXC') {
              disabled = true
            }
          })
        } else {
          disabled = true
        }
      }
      return disabled
    },
    haveActiveTPs () {
      if (this.trade.tpsteps && this.trade.tpsteps.length > 0) {
        let haveactive = false
        this.trade.tpsteps.forEach(step => {
          if (step.Status === 'ACT' || step.Status === 'NEW') {
            haveactive = true
          }
        })
        return haveactive
      } else {
        return false
      }
    },
    tradeAmount () {
      return new Decimal(this.trade.Qty).mul(this.trade.Price).toDP(8)
    },
    trade: {
      get () {
        return this.$store.state.trade.editTrade
      },
      set (value) {
        console.log('trade.set')
        this.$store.state.trade.editTrade = value
      }
    },
    tradeSteps () {
      if (this.trade.Sltp && this.trade.Sltp.Steps) {
        return this.trade.Sltp.Steps.Steps
      } else {
        return []
      }
    },
    expSLProfit () {
      let profit = new Decimal(0)
      if (!this.trade.Sltp) {
        return '0'
      }
      const slPrice = terminal.returnDecimalValue(this.trade.Sltp.SlPrice)
      if (slPrice.equals(0)) {
        return '0'
      }
      const qtyLeft =
        this.trade.Info && this.trade.Info.QtyLeft !== '0'
          ? this.trade.Info.QtyLeft
          : this.trade.Qty
      let invested = new Decimal(this.trade.Price).mul(this.trade.Qty)
      if (this.trade.so && this.trade.so.length > 0) {
        let totQty = new Decimal(0)
        let totAmount = new Decimal(0)
        if (this.trade.Status !== 'ORDSUBMIT' && this.trade.Status !== 'COND') {
          totQty = new Decimal(qtyLeft)
          totAmount = new Decimal(this.trade.Price).mul(qtyLeft)
        } else {
          invested = new Decimal(0)
        }
        this.trade.so.forEach(so => {
          if (so.Status !== 'EXC') {
            const soQty = terminal.returnDecimalValue(so.Qty)
            const soPrice = terminal.returnDecimalValue(so.Price)
            totQty = totQty.add(soQty)
            const amount = soPrice.mul(soQty)
            totAmount = totAmount.add(amount)
            invested = invested.add(amount)
          }
        })
        if (totQty.equals(0) || totAmount.equals(0)) {
          return '0'
        }
        const amountReceive = totQty.mul(slPrice)
        profit = amountReceive.sub(totAmount)
      } else {
        profit = slPrice.sub(this.trade.Price).mul(qtyLeft)
      }
      if (this.trade.Side === 'S') {
        profit = profit.neg()
      }

      // add realized profit
      profit = profit.add(this.trade.RProfit)

      const profitPct = profit
        .div(invested)
        .mul(100)
        .toDP(1)

      return {
        pft: profit.toDP(8).toString(),
        pct: profitPct.toString()
      }
    }
    // expSLProfitPct () {
    //   var prof = new Decimal(0)
    //   if (!this.trade.Sltp) {
    //     return '0'
    //   }
    //   var slPrice = terminal.returnDecimalValue(this.trade.Sltp.SlPrice)
    //   if (slPrice.equals(0)) {
    //     return '0'
    //   }
    //   if (this.trade.so && this.trade.so.length > 0) {
    //     var totQty = new Decimal(0)
    //     var totAmount = new Decimal(0)
    //     if (this.trade.Status !== 'ORDSUBMIT') {
    //       totQty = new Decimal(this.trade.Qty)
    //       totAmount = new Decimal(this.trade.Price).mul(this.trade.Qty)
    //     }
    //     this.trade.so.forEach(so => {
    //       if (so.Status !== 'EXC') {
    //         var soQty = terminal.returnDecimalValue(so.Qty)
    //         var soPrice = terminal.returnDecimalValue(so.Price)
    //         totQty = totQty.add(soQty)
    //         var amount = new Decimal(soPrice).mul(soQty)
    //         totAmount = totAmount.add(amount)
    //       }
    //     })
    //     if (totQty.equals(0) || totAmount.equals(0)) {
    //       return '0'
    //     }
    //     var avgPrice = totAmount.div(totQty)
    //     prof = slPrice.sub(avgPrice).mul(100).div(avgPrice).toDP(1)
    //   } else {
    //     prof = slPrice.sub(this.trade.Price).mul(100).div(this.trade.Price).toDP(1)
    //   }
    //   if (this.trade.Side === 'S') {
    //     prof = prof.neg()
    //   }
    //   return prof.toString()
    // }
  },
  beforeDestroy () {
    this.$store.commit('destroyModalObservers', this.closeOnEsc)
  },
  created () {
    this.refresh()
    this.setTPstepsAmount()
  },
  mounted () {
    this.$store.commit('setModalObservers', this.closeOnEsc)
  },
  methods: {
    rotateLiqPrice () {
      this.isRotateLiqPrice = true

      setTimeout(() => {
        this.isRotateLiqPrice = false
      }, 500)
    },
    updateLiquidatePrice () {
      this.isDisabledLiqPrice = true
      const params = {
        token: this.$store.state.sys.token,
        etid: this.$store.state.sys.tradeExchange.Id,
        tid: this.trade.Id
      }

      this.rotateLiqPrice()
      SlimApi.get('trade/upd_liqprice', {
        params
      })
        .then(response => {
          if (response.data.err) {
            this.$Message.warning({
              content: this.$text.tr('Ошибка') + ': ' + Util.returnTextForErr(response.data.err),
              duration: 5
            })
          } else {
            this.trade.Info.LiquidationPrice = response.data.liqprice
          }
        })
        .catch(function (error) {
          console.log(error)
        })

      setTimeout(() => {
        this.isDisabledLiqPrice = false
      }, 10 * 1000)
    },
    setComment (comment) {
      this.trade.Info.Comment = comment
    },
    showEditCommentModal (trade) {
      this.$store.state.editCommentModal.tid = trade.Id
      this.$store.state.editCommentModal.comment = trade.Info
        ? trade.Info.Comment
        : ''
      this.$store.state.editCommentModal.show = true
    },
    closeOnEsc (event) {
      if (event.keyCode === 27) {
        this.cancel()
      }
    },
    switchToPreviousTrade () {
      if (!this.isFirstTrade) {
        this.isSwitchingTrade = true
        const previousIndex = this.$store.state.trades.choosenTradeIndex - 1
        this.switchTrade(previousIndex)
      }
    },
    switchToNextTrade () {
      if (!this.isLastTrade) {
        this.isSwitchingTrade = true
        const nextIndex = this.$store.state.trades.choosenTradeIndex + 1
        this.switchTrade(nextIndex)
      }
    },
    async switchTrade (index) {
      const newTrade = this.tradesFiltered[index]

      if (!newTrade) {
        return
      }

      if (this.$store.state.trades.filt.type === 'act') {
        if (!this.$store.state.trade.tvEnabled) {
          this.$store.state.trade.showTV = true
          await setTimeout(() => {
            terminal.tradeGetAndSet(newTrade.Id)
          }, 3000)
        } else {
          this.$store.state.trade.showTV = true
          await terminal.tradeGetAndSet(newTrade.Id)
        }
      } else {
        this.$store.state.trade.editTradeId = null
        this.$store.state.trade.editTrade = null
      }
      terminal.selectSymbol(newTrade.Symbol)

      this.$store.state.trades.choosenTradeIndex = index
    },
    setTPstepsAmount () {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      const priceDec = this.symbolsFilter[this.$store.state.trade.symbol].PriceDec
      const amountDec = parseFloat(qtyDec) + parseFloat(priceDec)

      this.tradeTPs.forEach(step => {
        step.Amount = new Decimal(step.Qty)
          .mul(step.Price)
          .toDP(amountDec, Decimal.ROUND_DOWN)
          .toString()
      })
    },
    throwLeftQtyToLastElement () {
      const qtyLeft = this.checkPctQtyError()

      if (qtyLeft) {
        const lastElemnt = this.trade.tpsteps.slice(-1)[0]
        lastElemnt.Qty = new Decimal(lastElemnt.Qty).add(qtyLeft).toString()
      }
    },
    throwLeftPctToLastElement () {
      const pctLeft = this.checkPctTotal()

      if (pctLeft) {
        const lastElemnt = this.trade.tpsteps.slice(-1)[0]
        lastElemnt.Pct = new Decimal(lastElemnt.Pct).add(pctLeft).toString()
      }
    },
    onTakeProfitQtyChange (step) {
      this.setTakeProfitPct(step)
      this.setTakeProfitAmount(step)
      this.throwLeftPctToLastElement()
    },
    onTakeProfitAmountChange (step) {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      step.Qty = new Decimal(step.Amount)
        .div(step.Price)
        .toDP(qtyDec, Decimal.ROUND_DOWN)
        .toString()

      this.setTakeProfitPct(step)
      this.throwLeftQtyToLastElement()
    },
    onTakeProfitPctChange (step) {
      this.setTakeProfitQty(step)
      this.setTakeProfitAmount(step)
    },
    setTakeProfitQty (step) {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      let tradeQty = this.trade.Qty
      if (
        this.trade.Status === 'ORDSUBMIT' &&
        this.trade.so &&
        this.trade.so.length > 0
      ) {
        tradeQty = terminal.returnDecimalValue(this.trade.so[0].Qty)
      }

      step.Qty = new Decimal(tradeQty)
        .mul(step.Pct)
        .mul('0.01')
        .toDP(qtyDec, Decimal.ROUND_DOWN)
        .toString()
      this.throwLeftQtyToLastElement()
    },
    setTakeProfitPct (step) {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      let tradeQty = this.trade.Qty
      if (
        this.trade.Status === 'ORDSUBMIT' &&
        this.trade.so &&
        this.trade.so.length > 0
      ) {
        tradeQty = terminal.returnDecimalValue(this.trade.so[0].Qty)
      }

      tradeQty = new Decimal(tradeQty)
        .toDP(qtyDec, Decimal.ROUND_DOWN)
        .toString()

      step.Pct = new Decimal(step.Qty)
        .div(tradeQty)
        .mul('100')
        .toDP(0)
        .toString()
    },
    setTakeProfitAmount (step) {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      step.Amount = new Decimal(step.Qty)
        .mul(step.Price)
        .toDP(qtyDec, Decimal.ROUND_DOWN)
        .toString()
    },
    soOptionsClick (so) {
      if (so.Trigger === '0' && so.TrailPct === '0') {
        this.triggerClick(so)
        Vue.set(so, 'Option', 'TRIGGER')
      } else if (so.Trigger !== '0' && so.TrailPct === '0') {
        so.Trigger = '0'
        so.TrailPct = '1'
        so.Trail = false
        so.Option = 'TRAILING'
      } else if (so.Trigger === '0' && so.TrailPct !== '0') {
        so.TrailPct = '0'
        so.Option = 'EMPTY'
      }
      // console.log('so', so)
    },
    triggerClick (so) {
      if (so.Trigger === '0') {
        const priceDec = this.symbolsFilter[this.trade.Symbol].PriceDec
        if (this.trade.Side === 'B') {
          so.Trigger = new Decimal(so.Price)
            .mul(1.01)
            .toDP(priceDec, Decimal.ROUND_DOWN)
            .toString()
        } else {
          so.Trigger = new Decimal(so.Price)
            .mul(0.99)
            .toDP(priceDec, Decimal.ROUND_DOWN)
            .toString()
        }
      } else {
        so.Trigger = '0'
      }
    },
    stepsProfitPct (allBuys) {
      let tradePrice = new Decimal(this.trade.Price)
      let tradeQty = new Decimal(this.trade.Qty)
      if (allBuys === true || this.trade.Status === 'COND') {
        tradePrice = terminal.returnAverageTradePrice(this.trade)
        tradeQty = this.returnNewTradeQty(this.trade)
      } else if (this.trade.Status === 'ORDSUBMIT') {
        const qp = terminal.returnOrdSubmittedQtyPrice(this.trade)
        tradeQty = qp.qty
        tradePrice = qp.price
      }
      const stepsProfit = new Decimal(this.stepsProfit(allBuys))
      if (stepsProfit.equals(0) || tradePrice.equals(0) || tradeQty.equals(0)) {
        return '0'
      }
      return stepsProfit
        .div(tradePrice.mul(tradeQty))
        .mul(100)
        .toDP(1)
        .toString()
    },
    stepsProfit (allBuys) {
      let tradePrice = new Decimal(this.trade.Price)
      let tradeQty = new Decimal(this.trade.Qty)
      const qtyLeft =
        this.trade.Info && this.trade.Info.QtyLeft !== '0'
          ? new Decimal(this.trade.Info.QtyLeft)
          : tradeQty
      if (allBuys === true || this.trade.Status === 'COND') {
        tradePrice = terminal.returnAverageTradePrice(this.trade)
        const qtySold = tradeQty.sub(qtyLeft)
        tradeQty = this.returnNewTradeQty(this.trade).sub(qtySold)
        // console.log('tradeQty:', tradeQty.toString())
      } else if (this.trade.Status === 'ORDSUBMIT') {
        const qp = terminal.returnOrdSubmittedQtyPrice(this.trade)
        tradeQty = qp.qty
        tradePrice = qp.price
      }
      if (tradePrice.equals(0) || tradeQty.equals(0)) {
        return '0'
      }

      let profit = new Decimal(0)
      this.trade.tpsteps.forEach(step => {
        if (step.Status !== 'EXC') {
          const stepPrice = terminal.returnDecimalValue(step.Price)
          const stepPct = terminal.returnDecimalValue(step.Pct)
          let stepQty = step.Qty
          if (allBuys === true && qtyLeft.greaterThan(0)) {
            stepQty = new Decimal(step.Qty).div(qtyLeft).mul(tradeQty)
          }
          const stepPft = stepPrice.sub(tradePrice).mul(stepQty)
          // console.log('qtyLeft:', qtyLeft.toString(), 'tradeQty:', tradeQty.toString(), 'stepPct:', stepPct.toString(), 'stepPft:', stepPft.toString())
          profit = profit.add(stepPft)
        }
      })
      if (this.trade.Side === 'S') {
        profit = profit.neg()
      }

      profit = profit.add(this.trade.RProfit)

      return profit.toDP(8).toString()
    },
    updateTradeOrders () {
      // console.log('updateTradeOrders:', this.trade)
      terminal
        .tradeGet(this.trade.Id)
        .then(response => {
          if (response.status === Constants.http.OK) {
            // console.log('updateTradeOrders: ', response.data)
            // $store.state.trade.editTrade = response.data
            if (response.data.Orders) {
              this.trade.Orders = response.data.Orders
              this.tradeOrdersModalShow = true
            } else {
              this.$Notice.info({
                title: this.$text.tr('нет ордеров'),
                duration: 1
              })
            }
          } else {
            console.log('http error. status: ', status)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    numAfterDot (numb) {
      if (typeof numb === 'number') {
        numb = numb.toString()
      }
      // console.log(numb)
      // console.log(typeof numb)
      if (!numb.includes('.')) {
        return 0
      } else {
        return numb.split('.')[1].length
      }
    },
    soAmountChanged (index) {
      this.$store.state.trade.editQtyFocused = false
      if (this.tradeSOs[index].Amount === '') {
        return
      }
      let tradeSOIndex = index
      if (this.trade.so.length > this.tradeSOs.length) {
        tradeSOIndex = this.trade.so.length - (4 - index)
      }
      const newQty = new Decimal(this.trade.so[tradeSOIndex].Amount).div(
        this.trade.so[tradeSOIndex].Price
      )
      const filt = this.symbolsFilter[this.trade.Symbol]
      let qtyDec = 8
      if (filt) {
        qtyDec = filt.QtyDec
      }
      this.trade.so[tradeSOIndex].Qty = newQty
        .toDP(qtyDec, Decimal.ROUND_DOWN)
        .toString()
    },
    soQtyChanged (index) {
      this.$store.state.trade.editQtyFocused = true
      if (
        this.tradeSOs[index].Price === '' ||
        this.tradeSOs[index].Qty === ''
      ) {
        return
      }
      const filt = this.symbolsFilter[this.trade.Symbol]
      let amountDec = 8
      if (filt) {
        amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
      }
      let tradeSOIndex = index
      if (this.trade.so.length > this.tradeSOs.length) {
        tradeSOIndex = this.trade.so.length - (4 - index)
      }
      this.trade.so[tradeSOIndex].Amount = new Decimal(
        this.trade.so[tradeSOIndex].Price
      )
        .mul(this.trade.so[tradeSOIndex].Qty)
        .toDP(amountDec, Decimal.ROUND_DOWN)
        .toString()
    },
    soPriceChanged (index) {
      if (terminal.returnDecimalValue(this.tradeSOs[index].Price).equals(0)) {
        return
      }
      const filt = this.symbolsFilter[this.trade.Symbol]
      let qtyDec = 8
      let amountDec = 8
      if (filt) {
        qtyDec = filt.QtyDec
        amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
      }
      let tradeSOIndex = index
      if (this.trade.so.length > this.tradeSOs.length) {
        tradeSOIndex = this.trade.so.length - (4 - index)
      }
      if (this.$store.state.trade.editQtyFocused) {
        this.trade.so[tradeSOIndex].Amount = new Decimal(
          this.trade.so[tradeSOIndex].Price
        )
          .mul(this.trade.so[tradeSOIndex].Qty)
          .toDP(amountDec, Decimal.ROUND_DOWN)
          .toString()
      } else {
        this.trade.so[tradeSOIndex].Qty = new Decimal(
          this.trade.so[tradeSOIndex].Amount
        )
          .div(this.trade.so[tradeSOIndex].Price)
          .toDP(qtyDec, Decimal.ROUND_DOWN)
          .toString()
      }
    },
    returnNewTradeQty (trade) {
      let totQty = new Decimal(trade.Qty)
      if (trade.so && trade.so.length > 0) {
        if (trade.Status === 'ORDSUBMIT' || trade.Status === 'COND') {
          totQty = new Decimal(0)
        }
        trade.so.forEach(so => {
          if (so.Status !== 'EXC') {
            const soQty = terminal.returnDecimalValue(so.Qty)
            totQty = totQty.add(soQty)
          }
        })
      }
      // console.log(totQty.toString())
      return totQty
    },
    refresh () {
      this.updateTrailings()
      this.updateMarketSwitch()
      terminal.sortEditedTradeSO()
      if (this.trade.so) {
        this.tradeSOs = this.trade.so.slice(-4)
      }
      if (this.trade.tpsteps) {
        this.tradeTPs = this.trade.tpsteps.slice(-this.numberOfActiveTPs)
      }
    },
    cancelBuy (so) {
      terminal.cancelSO(so)
      // this.checkAllErrors()
    },
    addBuy () {
      if (
        this.trade.Status === 'ORDSUBMIT' &&
        this.trade.IntOrderId.length > 0
      ) {
        this.$Notice.error({
          title: 'Ошибка',
          desc:
            'Cтарая версия cделки. Чтобы использовать функцию усреднения, дождитесь исполнения начального ордера или создайте новую сделку',
          duration: 10
        })
        return
      }
      terminal.addNewSO()
      // this.checkAllErrors()
    },
    cancelTP (step) {
      const trade = this.$store.state.trade.editTrade
      if (trade) {
        trade.tpsteps = trade.tpsteps.filter(step1 => step1 !== step)
        this.resetTpSteps()
      }
    },
    addnewtp () {
      if (this.$store.state.trade.tvEnabled) {
        this.$store.state.calls.addnewtp = Date.now()
      } else {
        terminal.createTpStep()
        this.resetTpSteps()
      }
      this.scrollMainBottom()
    },
    scrollMainBottom () {
      setTimeout(() => {
        const main = document.getElementById('main')
        main.scrollTop = main.scrollHeight
      }, 200)
    },
    cancelSL () {
      this.$store.state.trade.slAdded = false
      if (this.trade.Sltp) {
        this.trade.Sltp.Status = 'NEW'
        this.trade.Sltp.SlPrice = '0'
      }
      if (this.trade.Info) {
        this.trade.Info.SlPct = '0'
      }
    },
    addstoploss () {
      this.$store.state.trade.slAdded = true
      if (
        this.trailing &&
        (!this.trade.Info || this.trade.Info.SlPct === '0')
      ) {
        if (!this.trade.Info) {
          Vue.set(this.trade, 'Info', { SlPct: '1' })
        } else {
          this.trade.Info.SlPct = '1'
        }
        if (!this.trade.Sltp) {
          Vue.set(this.trade, 'Sltp', { SlPrice: '0' })
        } else {
          this.trade.Sltp.SlPrice = '0'
        }
        return
      }
      const trade = this.$store.state.trade.editTrade
      const priceDec = this.symbolsFilter[trade.Symbol].PriceDec
      const mult = trade.Side === 'B' ? 0.99 : 1.01
      let comparePrice = this.$store.state.sys.lastPrice
      if (trade.Status === 'ORDSUBMIT') {
        comparePrice = trade.Price
      }
      if (!trade.Sltp) {
        // trade.Sltp = {}
        Vue.set(this.$store.state.trade.editTrade, 'Sltp', {
          SlPrice: new Decimal(comparePrice)
            .mul(mult)
            .toDP(priceDec, Decimal.ROUND_DOWN)
            .toString()
        })
        // console.log('editTrade.Sltp', this.$store.state.trade.editTrade.Sltp)
      } else {
        trade.Sltp.SlPrice = new Decimal(comparePrice)
          .mul(mult)
          .toDP(priceDec, Decimal.ROUND_DOWN)
          .toString()
      }
    },
    updateMarketSwitch () {
      if (this.trade.Tpsteps && this.trade.Tpsteps.length > 0) {
        let firstActiveStepIndex = 0
        for (let i = 0; i < this.trade.Tpsteps.length; i++) {
          if (this.trade.Tpsteps[i].Status === 'ACT') {
            firstActiveStepIndex = i
            break
          }
        }
        this.TpMarket = this.trade.Tpsteps[firstActiveStepIndex].Market
      } else {
        this.TpMarket = false
      }
    },
    tptypeswitch () {
      this.TpMarket = !this.TpMarket
    },
    typeString (type) {
      return Util.typeString(type)
    },
    checkAllErrors () {
      this.error = ''
      this.warn = ''
      if (!this.isSwitchingTrade) {
        this.checkTpWarn()
        this.checkTpError()
        this.checkPctQtyError()
        this.checkSlError()
        this.checkSoError()
      }
    },
    showCancelTradeConfirm () {
      let act = 'Отменить '
      if (this.trade.Status !== 'ORDSUBMIT' && this.trade.Status !== 'COND') {
        act = 'Выключить '
      }

      const modal = this.$store.state.confirmActionModal
      modal.text = act + 'сделку?'
      modal.btnName = 'ДА'
      modal.tradeId = this.trade.Id
      modal.actionId = this.trade.Status
      modal.actionFunc = terminal.cancelOrCloseTrade
      modal.show = true
    },
    panicSellByMode () {
      const actionId = this.trade.Side === 'S' ? 'panicbuy' : 'panicsell'

      if (this.$store.state.sys.isNoConfirmationMode) {
        terminal.panicSell(this.trade.Id, actionId)
      } else {
        this.showPanicSellModal(actionId)
      }
    },
    showPanicSellModal (actionId) {
      let txt = this.$text.tr('Продать по рынку?')
      let txt2 = this.$text.tr('Продать')

      if (actionId === 'panicbuy') {
        txt = this.$text.tr('Выкупить по рынку?')
        txt2 = this.$text.tr('Выкупить')
      }

      const modal = this.$store.state.confirmActionModal
      modal.text = txt
      modal.btnName = txt2
      modal.tradeId = this.trade.Id
      modal.actionId = actionId
      modal.actionFunc = terminal.panicSell
      modal.show = true
    },
    showRebuy () {
      this.$store.state.rebuyModal.show = true
      this.$store.state.rebuyModal.rebuyTrade = this.trade
    },
    updateTrailings () {
      if (
        (this.trade.Sltp && parseFloat(this.trade.Sltp.SlTrailPct) > 0) ||
        (this.trade.Info && parseFloat(this.trade.Info.SlTrailPct) > 0)
      ) {
        this.slTrailingEnabled = true
      } else {
        this.slTrailingEnabled = false
      }
      if (this.trade.Sltp && parseFloat(this.trade.Sltp.TpTrailPct) > 0) {
        this.tpTrailingEnabled = true
        this.tpTrailingPct = this.trade.Sltp.TpTrailPct
      } else {
        this.tpTrailingEnabled = false
        this.tpTrailingPct = 1
      }

      if (this.trade.Info && this.trade.Info.Breakeven) {
        this.breakeven = true
      } else {
        this.breakeven = false
      }

      if (this.trade.Info && this.trade.Info.AutoTp) {
        this.tpAutoEnabled = true
        this.tpAutoPct = this.trade.Info.AutoTpPct
      } else {
        this.tpAutoEnabled = false
        this.tpAutoPct = 0
      }

      if (this.trade.Sltp && parseFloat(this.trade.Sltp.SlTimeout) > 0) {
        this.slTimeoutEnabled = true
        this.slTimeout = parseFloat(this.trade.Sltp.SlTimeout)
      } else if (this.trade.Info && parseFloat(this.trade.Info.SlTimeout) > 0) {
        this.slTimeoutEnabled = true
        this.slTimeout = parseFloat(this.trade.Info.SlTimeout)
      } else {
        this.slTimeoutEnabled = false
        this.slTimeout = 60
      }

      if (this.trade.Sltp && this.trade.Sltp.SLCPeriod > 0) {
        this.$store.state.trade.slcEnabled = true
        this.slcPeriod = this.trade.Sltp.SLCPeriod
      } else if (this.trade.Info && this.trade.Info.SLCPeriod > 0) {
        this.$store.state.trade.slcEnabled = true
        this.slcPeriod = this.trade.Info.SLCPeriod
      } else {
        this.$store.state.trade.slcEnabled = false
        this.slcPeriod = 1
      }

      if (this.trade.Sltp && this.trade.Sltp.SlType === 'SLE') {
        this.slExchEnabled = true
      } else {
        this.slExchEnabled = false
      }
    },
    cancel () {
      this.$store.state.trade.editTradeId = null
      this.$store.state.trade.editTrade = null
      this.$store.state.trade.slcEnabled = false
    },
    checkSlError () {
      // console.log('trade sl', this.trade.Sltp.SlPrice, this.$store.state.sys.lastPrice)

      let amountMin = ''
      const filt = this.symbolsFilter[this.trade.Symbol]
      if (filt) {
        amountMin = new Decimal(1.05).mul(filt.AmountMin).toString()
      }

      if (this.trade.Sltp && this.trade.Sltp.SlPrice !== '0') {
        const slPrice = terminal.returnDecimalValue(this.trade.Sltp.SlPrice)
        if (this.trade.Status === 'ORDSUBMIT' || this.trade.Status === 'COND') {
          let comparePrice = this.trade.Price
          if (this.trade.so && this.trade.so.length > 0) {
            comparePrice = terminal.returnDecimalValue(this.trade.so[0].Price)
          }
          if (
            this.trade.Side === 'B' &&
            slPrice.greaterThanOrEqualTo(comparePrice)
          ) {
            this.error = this.$text.tr(
              'Stop Loss должен быть ниже цены покупки'
            )
          }
          if (
            this.trade.Side === 'S' &&
            slPrice.lessThanOrEqualTo(comparePrice)
          ) {
            this.error = this.$text.tr(
              'Stop Loss должен быть выше цены продажи'
            )
          }
        } else {
          if (
            this.trade.Side === 'B' &&
            slPrice.greaterThanOrEqualTo(this.$store.state.sys.lastPrice) &&
            !this.$store.state.trade.slcEnabled
          ) {
            this.error = this.$text.tr(
              'Stop Loss должен быть ниже текущей цены'
            )
          }
          if (
            this.trade.Side === 'S' &&
            slPrice.lessThanOrEqualTo(this.$store.state.sys.lastPrice) &&
            !this.$store.state.trade.slcEnabled
          ) {
            this.error = this.$text.tr(
              'Stop Loss должен быть выше текущей цены'
            )
          }
        }

        if (this.trade.so && this.trade.so.length > 0) {
          let maxOrd = 0
          let minOrd = Number.MAX_SAFE_INTEGER

          this.trade.so.forEach(el => {
            const soPrice = terminal.returnDecimalValue(el.Price)
            if (el.Status === 'ACT' && soPrice.lessThan(minOrd)) {
              minOrd = soPrice
            }
            if (el.Status === 'ACT' && soPrice.greaterThan(maxOrd)) {
              maxOrd = soPrice
            }
          })

          if (this.trade.Side === 'B' && slPrice.greaterThanOrEqualTo(minOrd)) {
            this.error = this.$text.tr(
              'Stop Loss должен быть ниже всех покупок'
            )
          }
          if (this.trade.Side === 'S' && slPrice.lessThanOrEqualTo(maxOrd)) {
            this.error = this.$text.tr('Stop Loss должен быть выше всех продаж')
          }
        }

        if (this.trade.ExchId !== 'BYF' && (new Decimal(this.trade.Qty).mul(slPrice).lessThan(amountMin))) {
          this.error = this.$text.tr('Stop Loss меньше минимального объема')
        }

        if (
          this.trade.Side === 'B' &&
          new Decimal(slPrice).greaterThan(this.trade.Price) &&
          this.breakeven
        ) {
          this.error = this.$text.tr(
            'Stop Loss выше средней цены, выключите безубыток'
          )
        } else if (
          this.trade.Side === 'S' &&
          new Decimal(slPrice).lessThan(this.trade.Price) &&
          this.breakeven
        ) {
          this.error = this.$text.tr(
            'Stop Loss ниже средней цены, выключите безубыток'
          )
        }
      }
    },
    checkPctQtyError () {
      if (this.trade.tpsteps && this.trade.tpsteps.length > 0) {
        let sumPctOfHiddenSteps = 0
        let sumQtyOfHiddenSteps = new Decimal(0)

        if (this.trade.tpsteps.length > this.numberOfActiveTPs) {
          const hiddenSteps = this.trade.tpsteps.slice(
            0,
            this.trade.tpsteps.length - this.numberOfActiveTPs
          )
          hiddenSteps.forEach(step => {
            const parsedPct = parseFloat(step.Pct)

            sumPctOfHiddenSteps += isNaN(parsedPct) ? 0 : parsedPct
            sumQtyOfHiddenSteps = sumQtyOfHiddenSteps.add(step.Qty)
          })
        }

        let sumPct = 0
        let sumQty = new Decimal(0)

        this.tradeTPs.forEach(step => {
          const parsedPct = parseFloat(step.Pct)

          sumPct += isNaN(parsedPct) ? 0 : parsedPct
          sumQty = sumQty.add(step.Qty)
          this.checkMaxQtyDecError(step)
        })

        if (sumPctOfHiddenSteps + sumPct !== 100) {
          const sumPctShouldBe = 100 - sumPctOfHiddenSteps
          this.error =
            this.$text.tr('Cумма TP должна быть') +
            ' ' +
            sumPctShouldBe +
            this.$text.tr('% (Cейчас:') +
            ' ' +
            sumPct +
            ')'
        } else {
          const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
          const sumQtyShouldBe = new Decimal(this.currentQty)
            .sub(sumQtyOfHiddenSteps)
            .toDP(qtyDec, Decimal.ROUND_DOWN)

          if (!sumQty.eq(sumQtyShouldBe)) {
            this.error =
              this.$text.tr('Кол-во в TP должно быть ') +
              ' ' +
              sumQtyShouldBe.toString() +
              this.$text.tr(' (Cейчас:') +
              ' ' +
              sumQty +
              ')'
            return sumQtyShouldBe.sub(sumQty).toString()
          }
        }
      }
    },
    checkMaxQtyDecError (step) {
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec

      if (this.numAfterDot(step.Qty) > qtyDec) {
        this.error = this.$text.tr(
          `Максимальное число знаков после запятой для количества ${qtyDec}`
        )
      }
    },
    checkPctTotal () {
      if (this.trade.tpsteps && this.trade.tpsteps.length > 0) {
        let sumPctOfHiddenSteps = 0
        let sumQtyOfHiddenSteps = new Decimal(0)

        if (this.trade.tpsteps.length > this.numberOfActiveTPs) {
          const hiddenSteps = this.trade.tpsteps.slice(
            0,
            this.trade.tpsteps.length - this.numberOfActiveTPs
          )
          hiddenSteps.forEach(step => {
            const parsedPct = parseFloat(step.Pct)

            sumPctOfHiddenSteps += isNaN(parsedPct) ? 0 : parsedPct
            sumQtyOfHiddenSteps = sumQtyOfHiddenSteps.add(step.Qty)
          })
        }

        let sumPct = 0
        let sumQty = new Decimal(0)

        this.tradeTPs.forEach(step => {
          const parsedPct = parseFloat(step.Pct)

          sumPct += isNaN(parsedPct) ? 0 : parsedPct
          sumQty = sumQty.add(step.Qty)
        })
        const sumQtyShouldBe = new Decimal(this.trade.Qty).sub(
          sumQtyOfHiddenSteps
        )

        if (sumPctOfHiddenSteps + sumPct !== 100 && sumQty.eq(sumQtyShouldBe)) {
          const sumPctShouldBe = 100 - sumPctOfHiddenSteps
          this.error =
            this.$text.tr('Cумма TP должна быть') +
            ' ' +
            sumPctShouldBe +
            this.$text.tr('% (Cейчас:') +
            ' ' +
            sumPct +
            ')'
          return sumPctShouldBe - sumPct
        }
      }
    },
    checkTpWarn () {
      if (
        this.trade.Status !== 'COND' &&
        this.trade.tpsteps &&
        this.trade.tpsteps.length > 0
      ) {
        this.tradeTPs.forEach((step, index) => {
          if (step.Status === 'ACT') {
            const stepPrice = terminal.returnDecimalValue(step.Price)
            if (
              this.trade.Side === 'B' &&
              stepPrice.lessThanOrEqualTo(this.$store.state.sys.lastPrice)
            ) {
              this.warn = this.$text.tr(
                'Внимание! Take Profit будет исполнен по рыночной цене'
              )
            }
            if (
              this.trade.Side === 'S' &&
              stepPrice.greaterThanOrEqualTo(this.$store.state.sys.lastPrice)
            ) {
              this.warn = this.$text.tr(
                'Внимание! Take Profit будет исполнен по рыночной цене'
              )
            }
          }
        })
      }
    },
    checkTpError () {
      if (this.trade.tpsteps && this.trade.tpsteps.length > 0) {
        const filt = this.symbolsFilter[this.trade.Symbol]
        let amountMin = filt.AmountMin
        amountMin = new Decimal(1.05).mul(amountMin).toString()

        this.tradeTPs.forEach((step, index) => {
          // new Decimal(this.stopLossPrice).mul(this.qty).lessThan(amountMin)
          if (step.Status === 'ACT' || step.Status === 'NEW') {
            const stepQty = terminal.returnDecimalValue(step.Qty)
            const stepPrice = terminal.returnDecimalValue(step.Price)
            const qty1 = stepQty.mul(stepPrice).toDP(8)
            // console.log('step.Price', step.Price)

            if (this.numAfterDot(step.Price) > filt.PriceDec) {
              this.error =
                'TP' +
                (index + 1) +
                this.$text.tr(
                  ': максимальное число знаков после запятой для цены'
                ) +
                ' ' +
                filt.PriceDec
            }

            if (qty1.lessThan(amountMin)) {
              // console.log('amountMin', amountMin)
              // console.log('qty1', qty1.toString())
              this.error =
                'TP' +
                (index + 1) +
                ' ' +
                this.$text.tr('меньше минимального объема')
            }

            if (this.trade.Status === 'ORDSUBMIT') {
              let tradePrice = this.trade.Price
              if (this.trade.so && this.trade.so.length > 0) {
                tradePrice = this.trade.so[0].Price
              }
              // console.log('tradePrice', tradePrice)
              if (
                this.trade.Side === 'B' &&
                stepPrice.lessThanOrEqualTo(tradePrice)
              ) {
                this.error = this.$text.tr(
                  'Take Profit должен быть выше цены покупки'
                )
              }
              if (
                this.trade.Side === 'S' &&
                stepPrice.greaterThanOrEqualTo(tradePrice)
              ) {
                this.error = this.$text.tr(
                  'Take Profit должен быть ниже цены продажи'
                )
              }
            } else {
              // if (this.trade.Side === 'B' && stepPrice.lessThanOrEqualTo(this.$store.state.sys.lastPrice)) {
              //   this.error = 'Take Profit должен быть выше текущей цены'
              // }
              // if (this.trade.Side === 'S' && stepPrice.greaterThanOrEqualTo(this.$store.state.sys.lastPrice)) {
              //   this.error = 'Take Profit должен быть ниже текущей цены'
              // }
            }
          }
        })

        this.checkSoTrailingPrice()

        if (this.trade.so && this.trade.so.length > 0) {
          let maxOrd = 0
          let minOrd = Number.MAX_SAFE_INTEGER

          this.trade.so.forEach(el => {
            const elPrice = terminal.returnDecimalValue(el.Price)
            if (el.Status === 'ACT' && elPrice.lessThan(minOrd)) {
              minOrd = elPrice
            }
            if (el.Status === 'ACT' && elPrice.greaterThan(maxOrd)) {
              maxOrd = elPrice
            }
          })

          for (let i = 0; i < this.trade.tpsteps.length; i++) {
            if (this.trade.tpsteps[i].Status === 'EXC') {
              continue
            }
            const tpstepPrice = terminal.returnDecimalValue(
              this.trade.tpsteps[i].Price
            )
            if (
              this.trade.Side === 'S' &&
              tpstepPrice.greaterThanOrEqualTo(minOrd)
            ) {
              this.error = this.$text.tr(
                'Take Profit должен быть ниже всех продаж'
              )
              break
            }
            if (
              this.trade.Side === 'B' &&
              tpstepPrice.lessThanOrEqualTo(maxOrd)
            ) {
              this.error = this.$text.tr(
                'Take Profit должен быть выше всех покупок'
              )
              break
            }
          }
        }
      }
    },
    checkSoTrailingPrice () {
      if (this.trade.so && this.trade.so.length > 0) {
        this.trade.so.forEach(so => {
          let diff = new Decimal(0)
          let trailPrice = new Decimal(0)
          if (so.Status === 'ACT' && parseFloat(so.TrailPct) > 0) {
            if (!so.Trail) {
              diff = new Decimal(so.Price)
                .mul(so.TrailPct)
                .div(new Decimal(100))
            }
            if (this.trade.Side === 'B') {
              trailPrice = new Decimal(so.Price).add(diff)
            } else {
              trailPrice = new Decimal(so.Price).sub(diff)
            }
          }
          const filt = this.symbolsFilter[this.trade.Symbol]
          if (filt) {
            trailPrice = trailPrice.toDP(filt.PriceDec)
          }
          // console.log('trailPrice', trailPrice.toString())
          if (trailPrice.greaterThan(new Decimal(0))) {
            for (let i = 0; i < this.trade.tpsteps.length; i++) {
              if (
                this.tpTrailingEnabled &&
                i === this.trade.tpsteps.length - 1
              ) {
                break
              }
              const step = this.trade.tpsteps[i]
              if (step.Status !== 'EXC') {
                if (this.trade.Side === 'B') {
                  if (new Decimal(step.Price).lessThan(trailPrice)) {
                    this.error =
                      this.$text.tr(
                        'TP должен быть больше Trailing цены покупки: > '
                      ) + trailPrice.toString()
                    break
                  }
                } else {
                  if (new Decimal(step.Price).greaterThan(trailPrice)) {
                    this.error =
                      this.$text.tr(
                        'TP должен быть меньше Trailing цены продажи: < '
                      ) + trailPrice.toString()
                    break
                  }
                }
              }
            }
            // для последней ступени с трейлингом
            if (this.tpTrailingEnabled) {
              const lastStepPrice = new Decimal(
                this.trade.tpsteps[[this.trade.tpsteps.length - 1]].Price
              )
              let stepTrailingPrice = new Decimal(0)
              diff = lastStepPrice.mul(this.tpTrailingPct).div(new Decimal(100))
              if (this.trade.Side === 'B') {
                stepTrailingPrice = lastStepPrice.add(diff)
                if (stepTrailingPrice.lessThan(trailPrice)) {
                  this.error = this.$text.tr(
                    'TP Trailing цена должна быть больше Trailing цены покупки: > ' +
                      +trailPrice.toString()
                  )
                }
              } else {
                stepTrailingPrice = lastStepPrice.sub(diff)
                if (stepTrailingPrice.greaterThan(trailPrice)) {
                  this.error = this.$text.tr(
                    'TP Trailing цена должна быть меньше Trailing цены продажи: < ' +
                      +trailPrice.toString()
                  )
                }
              }
              // console.log('stepTrailingPrice', stepTrailingPrice.toString())
            }
          }
        })
      }
    },
    checkSoError () {
      if (this.trade.so && this.trade.so.length > 0) {
        let amountMin = ''
        const filt = this.symbolsFilter[this.trade.Symbol]
        if (filt) {
          amountMin = new Decimal(1.05).mul(filt.AmountMin).toString()
        }

        this.tradeSOs.forEach((so, index) => {
          if (so.Status === 'ACT' || so.Status === 'NEW') {
            let buyText = this.$text.tr('Покупка')
            if (this.trade.Side === 'S') {
              buyText = this.$text.tr('Продажа')
            }
            const soQty = terminal.returnDecimalValue(so.Qty)
            const soPrice = terminal.returnDecimalValue(so.Price)
            const qty1 = soQty.mul(soPrice).toDP(8)
            if (qty1.lessThan(amountMin)) {
              this.error =
                buyText +
                ' ' +
                (index + 1) +
                ' ' +
                this.$text.tr('меньше минимального объема')
            }

            if (
              this.trade.ExchId === 'BYF' &&
              filt.PriceMin.last !== 1
            ) {
              if (!new Decimal(soPrice).div(filt.PriceMin).isInt()) {
                this.error =
                  buyText +
                  ' ' +
                  (index + 1) +
                  ' ' + this.$text.tr(': цена должна быть кратна ' + filt.PriceMin)
              }
            }

            if (this.numAfterDot(so.Price) > filt.PriceDec) {
              this.error =
                buyText +
                ' ' +
                (index + 1) +
                this.$text.tr(
                  ': максимальное число знаков после запятой для цены'
                ) +
                ' ' +
                filt.PriceDec
            }

            if (soQty.lessThan(filt.QtyMin)) {
              this.error =
                buyText +
                (index + 1) +
                this.$text.tr(': минимальное кол-во:') +
                ' ' +
                filt.QtyMin
            } else if (this.numAfterDot(so.Qty) > filt.QtyDec) {
              this.error =
                buyText +
                (index + 1) +
                this.$text.tr(
                  ': максимальное число знаков после запятой для кол-ва'
                ) +
                ' ' +
                filt.QtyDec
            }
            // if ((this.trade.Side === 'B' && new Decimal(so.Price).greaterThanOrEqualTo(this.$store.state.sys.lastPrice)) ||
            //   (this.trade.Side === 'S' && new Decimal(so.Price).lessThanOrEqualTo(this.$store.state.sys.lastPrice))) {
            //   this.error = buyText + (index + 1) + ' по рынку'
            // }
          }
        })
      }

      if (
        this.trade.Status === 'ORDSUBMIT' &&
        (!this.trade.so || this.trade.so.length === 0) &&
        this.trade.IntOrderId === ''
      ) {
        let side1 = 'покупку'
        if (this.trade.Side === 'S') {
          side1 = 'продажу'
        }
        this.error = this.$text.tr('Добавьте ' + side1)
      }
    },
    resetTpSteps (isChangePcts = true) {
      if (!this.trade.tpsteps) {
        return
      }
      const qtyDec = this.symbolsFilter[this.$store.state.trade.symbol].QtyDec
      const qtyMin = this.symbolsFilter[this.$store.state.trade.symbol].QtyMin
      let qtyPctSteps = new Decimal(0)
      let qtySteps = new Decimal(0)
      let freePcts = 100
      let numberOfExeSteps = 0
      const tradeQty = this.currentQty

      if (this.trade && this.trade.tpsteps) {
        this.trade.tpsteps.forEach(step => {
          if (step.Status === 'EXC') {
            freePcts -= step.Pct
            numberOfExeSteps += 1
            qtySteps = qtySteps.add(step.Qty)
          }
        })

        this.trade.tpsteps.forEach((step, index) => {
          step.Amount = new Decimal(step.Qty)
            .mul(step.Price)
            .toDP(qtyDec, Decimal.ROUND_DOWN)
            .toString()

          if (step.Status === 'EXC') {
            return
          }

          if (index === this.trade.tpsteps.length - 1) {
            if (isChangePcts) {
              step.Pct = new Decimal(freePcts).sub(qtyPctSteps).toString()
            }
            step.Qty = new Decimal(tradeQty)
              .sub(qtySteps)
              .toDP(qtyDec, Decimal.ROUND_DOWN)
              .toString()
          } else {
            if (isChangePcts) {
              step.Pct = new Decimal(freePcts)
                .div(this.trade.tpsteps.length - numberOfExeSteps)
                .toDP(0, Decimal.ROUND_DOWN)
                .toString()
            }
            step.Qty = new Decimal(tradeQty)
              .mul(step.Pct)
              .mul('0.01')
              .toDP(qtyDec, Decimal.ROUND_HALF_UP)
              .toString()

            if (this.trade.ExchId === 'BYF' || (this.trade.ExchId === 'OKX' && this.trade.Symbol.includes('-PERP'))) {
              step.Qty = this.roundQtyWithStep(step.Qty, qtyMin).toString()
            }

            qtyPctSteps = qtyPctSteps.add(step.Pct)
            qtySteps = qtySteps.add(step.Qty)
          }
        })
      }
    },
    truncateQtyWithStep (qty, step) {
      qty = new Decimal(qty)
      step = new Decimal(step)
      if (step.greaterThan(0)) {
        return qty
          .div(step)
          .toDP(0)
          .mul(step)
      } else {
        return qty
      }
    },
    roundQtyWithStep (qty, step) {
      qty = new Decimal(qty)
      step = new Decimal(step)
      if (step.greaterThan(0)) {
        return qty
          .div(step)
          .round()
          .mul(step)
      } else {
        return qty
      }
    },
    errorByPrice (stepOrSo, price) {
      let errArray = this.errRespTP
      if (stepOrSo === 'so') {
        errArray = this.errRespSO
      }
      if (!errArray) {
        return ''
      }
      if (!errArray[price]) {
        return ''
      }
      const errText = errArray[price]
      return Util.returnTextForErr(errText)
    },
    save () {
      terminal.sortEditedTradeSO()
      // console.log('url', this.formUrl())

      let url =
        'trade/set_sltp?token=' +
        this.$store.state.sys.token +
        '&etid=' +
        this.$store.state.sys.tradeExchange.Id +
        '&trade_id=' +
        this.trade.Id

      url += this.formUrl()

      // console.log('set sltp url', url)

      this.loading = true

      SlimApis[Util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get(url)
        .then(response => {
          // console.log('edit resp: ', response.data)
          if (response.status === Constants.http.OK) {
            let errOccurred = false
            if (response.data.err) {
              this.showError(response.data.err)
            } else {
              this.errRespTP = response.data.steps
              this.errRespSO = response.data.so
              if (this.trade && this.trade.tpsteps) {
                this.trade.tpsteps.forEach((step, i) => {
                  if (!step.Id) {
                    step.Id = response.data.steps['newid' + step.Price]
                  } else {
                    const newid = response.data.steps['updid' + step.Id]
                    if (newid) {
                      step.Id = newid
                    }
                  }
                  if (
                    errOccurred === false &&
                    this.errorByPrice('step', step.Price).length > 0
                  ) {
                    errOccurred = true
                  }
                })
              }
              if (this.trade && this.trade.so) {
                this.trade.so.forEach((so, i) => {
                  if (!so.Id) {
                    so.Id = response.data.so['newid' + so.Price]
                  } else {
                    const newid = response.data.so['updid' + so.Id]
                    if (newid) {
                      so.Id = newid
                    }
                  }
                  if (
                    errOccurred === false &&
                    this.errorByPrice('so', so.Price).length > 0
                  ) {
                    errOccurred = true
                  }
                })
              }
              // console.log('tpsteps: ', this.trade.tpsteps)
              // console.log('so: ', this.trade.so)

              // terminal.tradeGetAndSet(this.trade.Id)

              if (errOccurred) {
                this.$Notice.error({
                  title: this.$text.tr('Сделка сохранена с ошибкой'),
                  duration: 10
                })
              } else {
                this.$Notice.info({
                  title: this.$text.tr('Сделка сохранена'),
                  duration: 5
                })
              }
              this.loading = false
              this.$store.state.sys.lastTrade = Date.now()
            }
          } else {
            this.showError(this.$text.tr('Статус ') + response.status)
          }
        })
        .catch(error => {
          this.showError(error)
        })
    },
    showError (msg) {
      console.log('ERROR: ' + msg)

      if (msg.includes('кол-во должно быть кратно ')) {
        msg = msg.replace('кол-во должно быть кратно ', this.$text.tr('кол-во должно быть кратно '))
      }

      this.$Notice.error({
        title: this.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(msg),
        duration: 10
      })
      this.loading = false
    },
    formUrl () {
      let url = ''

      if (this.trade.Sltp && parseFloat(this.trade.Sltp.SlPrice) > 0) {
        url += '&sl_price=' + this.trade.Sltp.SlPrice
        if (this.slExchEnabled) {
          url += '&sle=1'
        }
      }

      if (this.trade.tpsteps && this.trade.tpsteps.length > 0) {
        url += '&tp_price=' + this.trade.tpsteps[0].Price

        let steps = ''
        // if (this.tpTrailingEnabled && parseFloat(this.tpTrailingPct) > 0) {
        // if (this.trade.v === 1) {
        //   if (this.trade.tpsteps.length > 1) {
        //     this.trade.tpsteps.forEach(step => {
        //       steps += ':' + step.Price + ':' + step.Pct + ':' + step.Qty + ':' + step.Status + ','
        //     })
        //   }
        // } else {
        this.trade.tpsteps.forEach(step => {
          steps +=
            (step.Id ? step.Id : '') +
            ':' +
            this.TpMarket +
            ':' +
            step.Price +
            ':' +
            step.Pct +
            ':' +
            step.Qty +
            ':' +
            step.Status +
            ','
        })
        // }
        url += '&tp_steps=' + steps
      }

      if (this.slTrailingEnabled) {
        let slTrailPct = '0'
        if (this.trade.Sltp && parseFloat(this.trade.Sltp.SlPrice) > 0) {
          slTrailPct = new Decimal(this.$store.state.sys.lastPrice)
            .sub(this.trade.Sltp.SlPrice)
            .mul(100)
            .div(this.$store.state.sys.lastPrice)
            .toDP(8)
            .toString()
        } else if (this.trade.Info && parseFloat(this.trade.Info.SlPct) > 0) {
          slTrailPct = this.trade.Info.SlPct
        }
        // console.log('slTrailPct:', slTrailPct)
        url += '&sl_trail_pct=' + slTrailPct
      }

      if (this.tpTrailingEnabled && parseFloat(this.tpTrailingPct) > 0) {
        url += '&tp_trail_pct=' + this.tpTrailingPct
      }

      if (this.tpAutoEnabled) {
        url += '&auto_tp_pct=' + this.tpAutoPct
      }

      // if (this.trade.Status === 'ORDSUBMIT') {
      //   url += '&newprice=' + this.trade.Price
      // }

      if (this.breakeven) {
        url += '&breakeven=1'
      }

      if (this.slTimeoutEnabled) {
        url += '&sl_timeout=' + this.slTimeout
      }

      if (this.trade.so && this.trade.so.length > 0) {
        if (this.trade.Status === 'COND') {
          url += '&cond_price=' + this.trade.so[0].Price
          url += '&cond_qty=' + this.trade.so[0].Qty
        } else {
          // id:trigger:price:qty:status
          let sostr = ''
          this.trade.so.forEach(sorder => {
            sostr +=
              (sorder.Id ? sorder.Id : '') +
              ':' +
              sorder.Trigger +
              ':' +
              sorder.Price +
              ':' +
              sorder.Qty +
              ':' +
              sorder.Status +
              ':' +
              sorder.TrailPct +
              ','
          })
          url += '&so=' + sostr
        }
      }

      if (this.$store.state.trade.slcEnabled) {
        url += '&slc=' + this.slcPeriod
      }

      if (
        this.trailing &&
        this.trade.Info &&
        parseFloat(this.trade.Info.SlPct) > 0
      ) {
        url += '&slpct=' + this.trade.Info.SlPct
      }
      // url += '&v=' + this.trade.v
      url += '&v=2'

      return url
    }
  }
}
</script>
